// extracted by mini-css-extract-plugin
export default {"description":"FacetFilter__description___oVtp0","items":"FacetFilter__items___zfag5","count":"FacetFilter__count___wLQQM"};